import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface ICreateProjectState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
  isEmailDuplicate: boolean;
}

export const CreateProjectEmptyState: ICreateProjectState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined,
  isEmailDuplicate: false
};
